import { Typography } from '@mui/material';
import { BarChart } from '@mui/x-charts/BarChart';
import { AiUsageRow } from '../../models/dtos/AiDto';
import { formatAiUsd } from './AiShared';

export function usageRowLabel(row: AiUsageRow): string {
    const parts: string[] = [];
    if (row.day) parts.push(row.day);
    if (row.caller) parts.push(row.caller);
    if (row.agentCode) parts.push(`agent ${row.agentCode}`);
    if (row.taskCode) parts.push(`task ${row.taskCode}`);
    if (row.modelKey) parts.push(row.modelKey);
    return parts.length > 0 ? parts.join(' · ') : '(none)';
}

/** Horizontal cost bars, top N by cost. */
export function CostBarChart({ rows, label, height, limit = 12 }: { rows: AiUsageRow[]; label: (row: AiUsageRow) => string; height?: number; limit?: number }) {
    const top = rows.slice().sort((a, b) => b.costUsd - a.costUsd).slice(0, limit);
    if (top.length === 0) return <Typography variant="body2" color="text.secondary">No usage in this period.</Typography>;
    const labels = top.map(label);
    const longest = labels.reduce((max, l) => Math.max(max, l.length), 0);
    return (
        <BarChart
            layout="horizontal"
            yAxis={[{ scaleType: 'band', data: labels }]}
            xAxis={[{ valueFormatter: (v: number) => formatAiUsd(v) }]}
            series={[{ data: top.map(r => r.costUsd), label: 'Cost (USD)', valueFormatter: (v: number | null) => formatAiUsd(v) }]}
            height={height ?? Math.max(180, 40 + top.length * 32)}
            margin={{ left: Math.min(320, 20 + longest * 7), right: 40, top: 20, bottom: 30 }}
            slotProps={{ legend: { hidden: true } }}
        />
    );
}
